function ConfirmDialog({
  open,
  title = "Confirm action",
  message = "Are you sure you want to continue?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  tone = "danger",
  busy = false,
  onConfirm,
  onCancel
}) {
  if (!open) return null;

  return (
    <div className="feedback-modal" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
      <div className={`feedback-card confirm-dialog-card ${tone === "danger" ? "danger" : ""}`}>
        <div className="feedback-card-header">
          <strong id="confirm-dialog-title">{title}</strong>
          <button className="feedback-close" type="button" onClick={onCancel} disabled={busy}>
            Close
          </button>
        </div>
        <p className="confirm-dialog-message">{message}</p>
        <div className="feedback-actions">
          <button className="secondary-button" type="button" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            className={tone === "danger" ? "danger-button" : "primary-button"}
            type="button"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "Working..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
